import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownIndicatorProps } from 'react-select';
import { GroupBase } from 'react-select/dist/declarations/src/types';

import styles from './Indicators.module.scss';

export function DropdownIndicator<Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  innerProps: { ref, ...props },
}: DropdownIndicatorProps<Option, IsMulti, Group>) {
  return (
    <div {...props} ref={ref} className={styles.indicator} data-testid="dropdown-indicator">
      <FontAwesomeIcon icon="chevron-down" />
    </div>
  );
}
